import styles from './PressReleaseList.module.css';
import classNames from 'classnames/bind';
import { INewsList } from 'types/news';

import dayjs from 'dayjs';
import Link from 'next/link';
import { useRouter } from 'next/router';
import ListThumbnail from 'components/common/ListThumbnail';

const cx = classNames.bind(styles);

interface IPressReleaseListProps {
  data: INewsList['data'];
  listItemURLQuery?: string;
}

function PressReleaseList({ data, listItemURLQuery }: IPressReleaseListProps) {
  const router = useRouter();

  const { pathname } = router;

  return (
    <section className={cx('wrapper')}>
      <div className={cx('wrapper')}>
        <ul className={cx('list')}>
          {data.map(({ id, attributes }) => (
            <Link
              key={id}
              href={`${pathname}/${id}?${listItemURLQuery}`}
              passHref
            >
              <a>
                <li>
                  <div className={cx('image-wrapper')}>
                    <ListThumbnail
                      url={
                        attributes.thumbnail.data?.attributes.formats?.medium
                          ?.url ||
                        attributes.thumbnail.data?.attributes.formats?.small
                          ?.url
                      }
                    />
                  </div>
                  <strong className={cx('text')}>{attributes.title}</strong>
                  <span className={cx('text', 'date')}>
                    {dayjs(
                      attributes.displayDate || attributes.createdAt
                    ).format('YYYY.MM.DD')}
                  </span>
                </li>
              </a>
            </Link>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default PressReleaseList;
